// Logic layer for the Market Analysis page: fetches exposure data from
// POST /admin/reports/market-analysis (existing endpoint) and groups it by
// `eventid` client-side. The page stays purely presentational.
//
// API ek event ke har market ko ALAG entry deta hai (same `eventid`, alag
// `match_id` — e.g. Normal + MATCH_ODDS = 2 entries). Reference me ek event =
// EK container jisme andar multiple market cards. Isliye yahan `eventid` pe
// group karke saare markets ek match object me merge karte hain.
import { useCallback, useEffect, useMemo, useState } from 'react'
import { getMarketAnalysis } from '../services/api'

// per-market_id entries ko eventid pe group karo (order preserve)
function groupByEvent(data) {
  const map = new Map()
  for (const entry of data) {
    const key = String(entry.eventid || entry.match_id || entry.match_title || '')
    if (!map.has(key)) map.set(key, { ...entry, markets: [...(entry.markets || [])] })
    else map.get(key).markets.push(...(entry.markets || []))
  }
  return [...map.values()]
}

export const useMarketAnalysis = () => {
  const [matches, setMatches] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)
    setError(null)
    // fa-spin takes 2s per rotation — hold the spinner for at least one full
    // turn even when the API responds instantly
    const minSpin = new Promise((resolve) => setTimeout(resolve, 2000))
    try {
      // existing endpoint har market_id ki alag entry deta hai — eventid pe group karo
      const response = await getMarketAnalysis()
      setMatches(response?.success ? groupByEvent(response.data || []) : [])
    } catch (err) {
      console.error('Failed to fetch market analysis:', err)
      setError(err?.message || 'Failed to load market analysis')
      setMatches([])
    } finally {
      await minSpin
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const filteredMatches = useMemo(() => {
    const term = search.trim().toLowerCase()
    if (!term) return matches
    return matches.filter((m) => (m.match_title || '').toLowerCase().includes(term))
  }, [matches, search])

  return { matches: filteredMatches, search, setSearch, loading, error, refresh: fetchData }
}

export default useMarketAnalysis
